// extracted by mini-css-extract-plugin
export var backButton = "_1d-1";
export var content = "_1d-d";
export var continueButton = "_1d-7";
export var continueHint = "_1d-8";
export var continueRow = "_1d-6";
export var leftInner = "_1d-0";
export var shell = "_1d-e";
export var sidebarContent = "_1d-5";
export var skipButton = "_1d-c";
export var spacer = "_1d-2";
export var spin = "_1d-a";
export var spinner = "_1d-9";
export var spinnerOverlay = "_1d-b";
export var subtitle = "_1d-4";
export var title = "_1d-3";